import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

import { BASE_TIMEZONE, BASE_DATE_FORMAT } from "./constants";

dayjs.extend(utc);
dayjs.extend(timezone);

export function formatInTimeZone(
  date,
  timezone = BASE_TIMEZONE,
  format = BASE_DATE_FORMAT
) {
  if (!date) {
    return null;
  }
  return dayjs.utc(date).tz(timezone).format(format);
}

export const formatDate = (date = new Date(), formatStr) => {
  return formatInTimeZone(date, BASE_TIMEZONE, formatStr);
};

// Gets min:seconds(str) from seconds(int)
export function formatTime(seconds) {
  const mins = Math.floor(seconds / 60)
  const secs = seconds % 60
  return `${mins}:${secs.toString().padStart(2, '0')}`
}